import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import css from 'swiper/css/swiper.css';
export default (_) => {
  Vue.use(VueAwesomeSwiper, { css });
}
